export const PROMO_TYPE_DISCOUNT = 'DISCOUNT';
